import Phaser from 'phaser';

export class TileAnimations {
  static dealToHand(scene: Phaser.Scene, tile: any, fromX: number, fromY: number, toX: number, toY: number, delay: number) {
    tile.setPosition(fromX, fromY);
    tile.setAlpha(0);
    tile.setScale(0.5);

    scene.tweens.add({
      targets: tile,
      x: toX,
      y: toY,
      alpha: 1,
      scale: 1,
      duration: 500,
      delay: delay,
      ease: 'Back.easeOut'
    });
  }

  static playToBoard(scene: Phaser.Scene, tile: any, targetX: number, targetY: number) {
    scene.tweens.add({
      targets: tile,
      x: targetX,
      y: targetY,
      duration: 400,
      ease: 'Power2'
    });
  }

  static hoverUp(scene: Phaser.Scene, tile: any) {
    if (tile._isHovering) return;
    tile._isHovering = true;
    tile._originalY = tile.y;
    scene.tweens.add({
      targets: tile,
      y: tile.y - 15,
      duration: 200,
      ease: 'Power2'
    });
  }

  static hoverDown(scene: Phaser.Scene, tile: any) {
    if (!tile._isHovering) return;
    tile._isHovering = false;
    scene.tweens.add({
      targets: tile,
      y: tile._originalY || tile.y + 15,
      duration: 200,
      ease: 'Power2'
    });
  }

  static shake(scene: Phaser.Scene, tile: any) {
    scene.tweens.add({
      targets: tile,
      x: { value: '+=10', duration: 50, yoyo: true, repeat: 3 },
      ease: 'Sine.easeInOut'
    });
  }

  static flipReveal(scene: Phaser.Scene, tileback: any, dominoTile: any) {
    scene.tweens.add({
      targets: tileback,
      scaleX: 0,
      duration: 200,
      onComplete: () => {
        tileback.setVisible(false);
        dominoTile.setScale(0, 1);
        dominoTile.setVisible(true);
        scene.tweens.add({
          targets: dominoTile,
          scaleX: 1,
          duration: 200
        });
      }
    });
  }

  static celebrationBounce(scene: Phaser.Scene, tiles: any[]) {
    scene.tweens.add({
      targets: tiles,
      y: '-=30',
      yoyo: true,
      repeat: -1,
      duration: 400,
      ease: 'Sine.easeInOut',
      delay: scene.tweens.stagger(100, {})
    });
  }
}
